import { useEffect, useRef, useState } from "react";
import Button from "../ui/Button";
import Select from "../ui/Select";
import { useAppLabel } from "../../utils/useAppLabel";
import { useCashierText } from "./cashierText";

export default function CreateOrderSheet({
  open,
  context,
  selectedStore,
  selectedBranch,
  onClose,
  onSubmit,
  busy,
}) {
  const [digits, setDigits] = useState(["", "", "", ""]);
  const [app, setApp] = useState("");
  const refs = useRef([]);
  const appLabel = useAppLabel();
  const { t } = useCashierText();
  const store = context.stores?.find((x) => x.id === selectedStore);
  const branch = store?.branches.find((x) => x.id === selectedBranch);
  const applicationOptions =
    branch?.applications?.map((item) => ({
      label: appLabel(item.app, item.name),
      value: item.id,
    })) || [];
  useEffect(() => {
    if (open) {
      setDigits(["", "", "", ""]);
      setApp(
        branch?.applications?.length === 1 ? branch.applications[0].id : "",
      );
      setTimeout(() => refs.current[0]?.focus(), 0);
    }
  }, [open, selectedStore, selectedBranch, branch]);
  if (!open) return null;
  const change = (index, value) => {
    const number = value.replace(/\D/g, "").slice(-1);
    const next = [...digits];
    next[index] = number;
    setDigits(next);
    if (number) refs.current[index + 1]?.focus();
  };
  return (
    <div className="cashier-modal">
      <form
        className="cashier-sheet create-sheet"
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit({
            last4: digits.join(""),
            storeId: selectedStore,
            branchId: selectedBranch,
            applicationId: app,
          });
        }}
      >
        <h3>{t.newOrder}</h3>
        <p>
          {store?.name} · {branch?.name}
        </p>
        <label>{t.last4Label}</label>
        <div className="cashier-digits" dir="ltr">
          {digits.map((digit, index) => (
            <input
              key={index}
              ref={(el) => (refs.current[index] = el)}
              value={digit}
              onChange={(e) => change(index, e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Backspace" && !digit)
                  refs.current[index - 1]?.focus();
              }}
              inputMode="numeric"
              maxLength="1"
              aria-label={t.digit(index + 1)}
            />
          ))}
        </div>
        <Select
          label={t.application}
          value={app}
          onChange={(e) => setApp(e.target.value)}
          disabled={!branch?.applications?.length}
          placeholder={
            branch?.applications?.length ? t.chooseApplication : t.noApplications
          }
          options={applicationOptions}
        />
        {!branch?.applications?.length && (
          <p>{t.noApplicationsHint}</p>
        )}
        <div className="cashier-sheet-actions">
          <Button type="button" variant="neutral" onClick={onClose}>
            {t.cancel}
          </Button>
          <Button
            type="submit"
            appearance="filled"
            disabled={busy || digits.join("").length !== 4 || !app}
          >
            {busy ? t.adding : t.addOrder}
          </Button>
        </div>
      </form>
    </div>
  );
}
